"use strict";

var _classCallCheck = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createTransitionContext = require("./createTransitionContext");

var _getPagesPromises = _interopRequireDefault(require("../utils/getPagesPromises"));

var _jsxFileName = "/Users/tyler/Documents/GitHub/gatsby-plugins/transition-link/gatsby-plugin-transition-link/src/context/InternalProvider.js";

var InternalProvider = /*#__PURE__*/function (_react$Component) {
  _inherits(InternalProvider, _react$Component);

  var _super = _createSuper(InternalProvider);

  function InternalProvider(props) {
    var _this;

    _classCallCheck(this, InternalProvider);

    _this = _super.call(this, props);
    var prefersReducedMotionSetting = typeof window !== "undefined" && window.matchMedia('(prefers-reduced-motion: reduce)');
    var prefersReducedMotion = prefersReducedMotionSetting;

    if (prefersReducedMotionSetting.matches && process.env.NODE_ENV === "development") {
      console.warn("[gatsby-plugin-transition-link] Warning! prefers-reduced-motion is activated via your OS settings. This means TransitionLink animations will not run.");
    }

    _this.state = {
      inTransition: false,
      disableAnimation: prefersReducedMotion.matches,
      // event
      e: false,
      // exit
      exitDelay: 0,
      exitLength: 0,
      exitState: {},
      exitProps: {},
      exitTrigger: false,
      // entry
      entryDelay: 0,
      entryLength: 0,
      entryState: {},
      entryProps: {},
      entryTrigger: false,
      // state updates
      updateContext: function updateContext(obj) {
        return _this.setState(obj);
      }
    };

    if (prefersReducedMotion && typeof prefersReducedMotion.addEventListener === "function") {
      prefersReducedMotion.addEventListener('change', function () {
        _this.setState({
          disableAnimation: prefersReducedMotion.matches
        });
      });
    } else if (prefersReducedMotion && typeof prefersReducedMotion.addListener === "function") {
      prefersReducedMotion.addListener(function () {
        _this.setState({
          disableAnimation: prefersReducedMotion.matches
        });
      });
    }

    return _this;
  }

  _createClass(InternalProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.updateContext((0, _getPagesPromises.default)());
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_createTransitionContext.Provider, {
        value: this.state,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 71,
          columnNumber: 10
        }
      }, this.props.children);
    }
  }]);

  return InternalProvider;
}(_react.Component);

InternalProvider.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = InternalProvider;
exports.default = _default;